import {
  Badge,
  Button,
  Grid,
} from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { useStyles } from "./CompanyGridToolbar.styles";
import React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import { useModal, useStore } from "src/Shared/Hooks";
import FilterAltTwoToneIcon from "@mui/icons-material/FilterAltTwoTone";
import CompanyGridFilterPanel from "../CompanyGridFilterPanel/CompanyGridFilterPanel";
import ClientSearch from "../ClientSearch/ClientSearch";

type Props = {
  onApplyFilter?: () => void;
};

const CompanyGridToolbar: React.FC<Props> = ({ onApplyFilter }: Props) => {
  const modal = useModal();

  const {
    rootStore: {
      companyStore: { companyFilterForm, companyFilterCollection },
    },
  } = useStore();

  const classes = useStyles();

  const badgeContent = () => {
    const collectionCount =
      (
        companyFilterCollection &&
        Object.values(companyFilterCollection).filter(
          (x: any) =>
            x != null &&
            x != "" &&
            (x.length > 0 ||
              (x instanceof Object &&
                ((x.hasOwnProperty("startDate") && x?.startDate != null) ||
                  (x.hasOwnProperty("min") && x?.min != null) ||
                  (x.hasOwnProperty("value") && x?.value != ""))) ||
              (typeof x == "number" && x > 0))
        )
      )?.length || 0;
    return collectionCount;
  };

  const onAdvanceFilterClick = () => {
    modal.open(
      <CompanyGridFilterPanel onApplyFilter={() => onApplyFilter()} />
    );
  };
  const onReset = () => {
    companyFilterForm.reset();
    onApplyFilter();
  };

  return (
    <GridToolbarContainer className={classes.container}>
      <Grid container>
        <Grid item lg={8} className={classes.filterBox}>
          <ClientSearch currentTab="home" />
        </Grid>
        <Grid item lg={4} className={classes.buttonBox}>
          {badgeContent() > 0 && (
            <Button
              variant="contained"
              startIcon={<FilterAltTwoToneIcon />}
              onClick={onReset}
              sx={{
                mr: 2,
              }}
            >
              Clear Filter
            </Button>
          )}

          <Badge
            color="secondary"
            badgeContent={badgeContent()}
            invisible={badgeContent() <= 0}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <Button
              variant="contained"
              startIcon={<FilterAltTwoToneIcon />}
              onClick={onAdvanceFilterClick}
              sx={{
                mr: 2,
              }}
            >
              Advanced Filter
            </Button>
          </Badge>
          <Button
            variant="contained"
            startIcon={<AddCircleIcon />}
            component={Link}
            to="/company/add"
          >
            Add New Client
          </Button>
        </Grid>
      </Grid>
    </GridToolbarContainer>
  );
};
export default observer(CompanyGridToolbar);
